import React from "react";

/**
 * Button
 * - Small shared button component used across the app.
 * - Props:
 *    - as: element or component to render (default "button")
 *    - variant: "solid" | "outline" (default "solid")
 *    - size: "sm" | "md" (default "md")
 *    - className: additional classes
 *    - rest props passed through
 *
 * Usage:
 *  <Button onClick={...}>Save</Button>
 *  <Button as={Link} to="/..." variant="outline" size="sm">View</Button>
 */

const Button = ({
  as: Component = "button",
  variant = "solid",
  size = "md",
  className = "",
  children,
  ...props
}) => {
  const base = "inline-flex items-center justify-center rounded";
  const sizes = {
    sm: "px-2 py-1 text-sm",
    md: "px-3 py-2",
  };
  const variants = {
    solid: "bg-brand text-white hover:bg-brand-700",
    outline: "border border-gray-300 text-gray-700 hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700",
  };

  const variantClass = variants[variant] || variants.solid;
  const sizeClass = sizes[size] || sizes.md;

  return (
    <Component
      className={`${base} ${sizeClass} ${variantClass} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Button;
